import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=31d70cd4&scoped=true&"
import script from "./PersonnelList.vue?vue&type=script&lang=js&"
export * from "./PersonnelList.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&id=31d70cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d70cd4",
  null
  
)

export default component.exports